// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3Cf9g","calendarButtons":"ClockData_calendarButtons__116pK"};